import React from 'react';
import './Stats.css';
import { toSentenceCase } from '../utils/textUtils';

function Stats() {
  const stats = [
    { number: '180+', label: toSentenceCase('Professeurs & encadreurs') },
    { number: '12', label: toSentenceCase('Filières techniques reconnues par l\'État') },
    { number: '10', label: toSentenceCase('Laboratoires modernes') },
    { number: '100%', label: toSentenceCase('Taux de réussite aux examens') },
    { number: '58', label: toSentenceCase('Entreprises partenaires') }
  ];

  return (
    <section className="stats section">
      <div className="container">
        <div className="stats-header">
          <h2 className="stats-title">{toSentenceCase("Chiffres clés")}</h2>
          <p className="stats-subtitle">
            {toSentenceCase("Des résultats qui témoignent de notre excellence et de notre engagement envers la réussite de nos élèves")}
          </p>
        </div>
        
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-item">
              <div className="stat-number">{stat.number}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Stats;
